<template>
<el-dialog :title="viewFlag === 'view' ? '查看供应商报价' : !dataForm || !dataForm.id ? '新增' : '修改'" :append-to-body="true" :close-on-click-modal="false" width="80%" :visible.sync="viewData.visible" :before-close="validData">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane key="totalPanel" label="报价汇总信息" name="totalPanel">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" size="small" label-width="0px" class="org-dialog-form">
                <div>
                    <el-row><span style="color:red">报价中涉及到的所有价格均为不含税价格，本次报价的价格总计会保留到小数点后{{this.dataForm.priceBit}}位</span></el-row>
                    <el-row>
                        <el-col :span="10">
                            <span>供应商：{{vender ? vender.venderName+"（"+vender.venderCode+"）" : ""}}&nbsp;&nbsp;</span>
                        </el-col>
                        <el-col :span="10">
                            <span>零件：{{(dataForm.partName || '') +"（"+ (dataForm.partCode || '') +"）"}}&nbsp;&nbsp;</span>
                        </el-col>
                        <el-col :span="4" v-if="viewFlag !== 'view'">
                            <div class="fr">
                                <el-checkbox v-model='chooseFlag' :true-label=1 :false-label=0 @change="changePriceMode">详细报价</el-checkbox>
                            </div>
                        </el-col>
                    </el-row>
                    
                </div>
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 5px;">
                        <el-descriptions-item label="原材料(A)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="materialCost">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.materialCost)}}</span>
                                <ctl-number v-else @change="changeToD('A',dataForm.materialCost)" :p="3" v-model="dataForm.materialCost" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="外购零件 (B)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="outsidePartCost">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.outsidePartCost)}}</span>
                                <ctl-number v-else @change="changeToD('B',dataForm.outsidePartCost)" :p="3" v-model="dataForm.outsidePartCost" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="加工费(C)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="processingCost">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.processingCost)}}</span>
                                <ctl-number v-else @change="changeToD('C',dataForm.processingCost)" :p="3" v-model="dataForm.processingCost" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="进口部分 (原材料)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="materialImportCost">
                                <span v-if="viewFlag === 'view'">{{fixedNumber3(dataForm.materialImportCost)}}</span>
                                <ctl-number v-else v-model="dataForm.materialImportCost" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="进口部分 (外购零件)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="importOutsidePartCost">
                                <span v-if="viewFlag === 'view'">{{fixedNumber3(dataForm.importOutsidePartCost)}}</span>
                                <ctl-number v-else v-model="dataForm.importOutsidePartCost" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="" :label-style="getStyle()" :content-style="getStyle2()">

                        </el-descriptions-item>
                        <el-descriptions-item label="制造成本小计(D=A+B+C)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:200px;margin-bottom: 0;" prop="productionCostSum">
                                <span>{{fixedNumber(dataForm.productionCostSum)}}</span>
                            </el-form-item>
                            <!-- <el-form-item style="width:200px;margin-bottom: 0;" prop="productionCostSum">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{dataForm.productionCostSum}}</span>
                                <ctl-number v-else disabled v-model="dataForm.productionCostSum" :precision="3" style="width:200px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item> -->
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 5px;">
                        <el-descriptions-item label="管理费用(E):" :label-style="getStyleRed()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="managementCost">
                                <span v-if="viewFlag === 'view'">{{dataForm.managementCost}}</span>
                                <ctl-number v-else @change="changeToH('E',dataForm.managementCost)" v-model="dataForm.managementCost" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="销售费用(F):" :label-style="getStyleRed()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="saleCost">
                                <span v-if="viewFlag === 'view'">{{dataForm.saleCost}}</span>
                                <ctl-number v-else @change="changeToH('F',dataForm.saleCost)" v-model="dataForm.saleCost" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="财务费用(G)" :label-style="getStyleRed()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="accountCost">
                                <span v-if="viewFlag === 'view'">{{dataForm.accountCost}}</span>
                                <ctl-number v-else @change="changeToH('G',dataForm.accountCost)" v-model="dataForm.accountCost" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="期间费用小计(H=E+F+G)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:200px;margin-bottom: 0;" prop="midiumCostSum">
                                <span>{{fixedNumber(dataForm.midiumCostSum)}}</span>
                            </el-form-item>
                            <!-- <el-form-item style="width:200px;margin-bottom: 0;" prop="midiumCostSum">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{dataForm.midiumCostSum}}</span>
                                <ctl-number v-else disabled v-model="dataForm.midiumCostSum" :precision="3" style="width:200px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item> -->
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 5px;">
                        <el-descriptions-item label="利润(I)" :label-style="getStyleRed()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="profit">
                                <span v-if="viewFlag === 'view'">{{fixedNumber3(dataForm.profit)}}</span>
                                <ctl-number v-else v-model="dataForm.profit" :precision="3" style="width:150px;" :min="0" :p="3" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="包装费(K)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="packageFee">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.packageFee)}}</span>
                                <ctl-number v-else @change="changeToM('K',dataForm.packageFee)" v-model="dataForm.packageFee" :p="3" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="运输费(L)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="transportFee">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.transportFee)}}</span>
                                <ctl-number v-else @change="changeToM('L',dataForm.transportFee)" v-model="dataForm.transportFee" :p="3" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="产品单价(J=D+H+I+K+L)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="productUnitPrice">
                                <span>{{fixedNumber(dataForm.productUnitPrice)}}</span>
                            </el-form-item>
                        </el-descriptions-item>

                        <el-descriptions-item label="产品价格总计(0=J+M+N)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;background-color:#E6A23C;" prop="feeCostSum">
                                <span>{{fixedNumber(dataForm.feeCostSum)}}</span>
                            </el-form-item>
                            <!-- <el-form-item style="width:100px;margin-bottom: 0;" prop="feeCostSum">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{dataForm.feeCostSum}}</span>
                                <ctl-number v-else disabled v-model="dataForm.feeCostSum" :precision="3" style="width:200px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item> -->
                        </el-descriptions-item>
                    </el-descriptions>


                    <el-descriptions  class="margin-top" :column="1" size="small" border style="margin-bottom: -1px;">
                      <el-descriptions-item label="模具/夹具/检具工装费用" :label-style="'width: 100%; text-align: center'" :content-style="'padding:0px'">
                      </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 5px;">
                          <el-descriptions-item label="总投资额" :label-style="getStyle()" :content-style="getStyle2()">
                              <el-form-item style="width:100px;margin-bottom: 0;" prop="toolsTotalInvestment">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.toolsTotalInvestment)}}</span>
                                <ctl-number v-else @change="changeToToolsRatio()" v-model="dataForm.toolsTotalInvestment" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                              </el-form-item>
                          </el-descriptions-item>
                          <el-descriptions-item label="支付比例(%)" :label-style="getStyle()" :content-style="getStyle2()">
                              <el-form-item style="width:100px;margin-bottom: 0;" prop="toolsPayRatio">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.toolsPayRatio)}}</span>
                                <ctl-number v-else @change="changeToToolsRatio()" v-model="dataForm.toolsPayRatio" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                              </el-form-item>
                          </el-descriptions-item>
                          <el-descriptions-item label="摊销金额" :label-style="getStyle()" :content-style="getStyle2()">
                              <el-form-item style="width:100px;margin-bottom: 0;" prop="toolsAmortizationAmount">
                                <span>{{fixedNumber3(dataForm.toolsAmortizationAmount)}}</span>
                              </el-form-item>
                          </el-descriptions-item>
                          <el-descriptions-item label="摊销数量" :label-style="getStyle()" :content-style="getStyle2()">
                              <el-form-item style="width:100px;margin-bottom: 0;" prop="toolsAmortizationNum">
                                <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber(dataForm.toolsAmortizationNum)}}</span>
                                <ctl-number v-else @change="changeToToolsRatio()" v-model="dataForm.toolsAmortizationNum" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                              </el-form-item>
                          </el-descriptions-item>
                          <el-descriptions-item label="分摊单价(M)" :label-style="getStyle()" :content-style="getStyle2()">
                              <el-form-item style="width:100px;margin-bottom: 0;" prop="toolsPartAllocation">
                                  <span>{{fixedNumber3(dataForm.toolsPartAllocation)}}</span>
                              </el-form-item>
                          </el-descriptions-item>
                    </el-descriptions>

                    <el-descriptions  class="margin-top" :column="1" size="small" border style="margin-bottom: -1px;">
                      <el-descriptions-item label="试验费/设计费用" :label-style="'width: 100%; text-align: center'" :content-style="'padding:0px'">
                      </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 15px;">
                      <el-descriptions-item label="费用明细" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="width:100px;margin-bottom: 0;" prop="designTotalInvestment">
                          <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber3(dataForm.designTotalInvestment)}}</span>
                                <ctl-number v-else @change="changeDesignRatio()" v-model="dataForm.designTotalInvestment" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                        </el-form-item>
                      </el-descriptions-item>
                      <el-descriptions-item label="支付比例(%)" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="width:100px;margin-bottom: 0;" prop="designPayRatio">
                          <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber(dataForm.designPayRatio)}}</span>
                                <ctl-number v-else @change="changeDesignRatio()" v-model="dataForm.designPayRatio" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                        </el-form-item>
                      </el-descriptions-item>
                      <el-descriptions-item label="摊销金额" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="width:100px;margin-bottom: 0;" prop="designAmortizationAmount">
                            <span>{{fixedNumber3(dataForm.designAmortizationAmount)}}</span>
                        </el-form-item>
                      </el-descriptions-item>
                      <el-descriptions-item label="摊销数量" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="width:100px;margin-bottom: 0;" prop="designAmortizationNum">
                            <span v-if="viewFlag === 'view' || chooseFlag">{{fixedNumber(dataForm.designAmortizationNum)}}</span>
                            <ctl-number v-else @change="changeDesignRatio()" v-model="dataForm.designAmortizationNum" :precision="3" :p="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                        </el-form-item>
                      </el-descriptions-item>
                      <el-descriptions-item label="分摊单价(N)" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="width:100px;margin-bottom: 0;" prop="designPartAllocation">
                          <span>{{fixedNumber3(dataForm.designPartAllocation)}}</span>
                        </el-form-item>
                      </el-descriptions-item>
                    </el-descriptions>


                </div>
                <div>
                    <el-row>
                        <el-col :span="12">
                            <h3>其他信息</h3>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 5px;">
                        <el-descriptions-item label="生产工厂所在地(省):" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="factoryDistrict">
                                <span v-if="viewFlag === 'view'">{{dataForm.factoryDistrict}}</span>
                                <el-input v-else v-model="dataForm.factoryDistrict" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="生产工厂所在地(市):" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="factoryCity">
                                <span v-if="viewFlag === 'view'">{{dataForm.factoryCity}}</span>
                                <el-input v-else v-model="dataForm.factoryCity" maxlength="50" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="到【北京汽车】距离(km):" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="distanceToBj">
                                <span v-if="viewFlag === 'view'">{{dataForm.distanceToBj}}</span>
                                <ctl-number v-else v-model="dataForm.distanceToBj" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="生产能力(件/月):" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="produceEnergy">
                                <span v-if="viewFlag === 'view'">{{dataForm.produceEnergy}}</span>
                                <ctl-number v-else v-model="dataForm.produceEnergy" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="开工率" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="workRate">
                                <span v-if="viewFlag === 'view'">{{dataForm.workRate}}</span>
                                <ctl-number v-else v-model="dataForm.workRate" :precision="3" style="width:150px;" :min="0" :max="9999999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价人电话:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="tel">
                                <span v-if="viewFlag === 'view'">{{dataForm.tel}}</span>
                                <el-input v-else v-model="dataForm.tel" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价人邮箱:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="fax">
                                <span v-if="viewFlag === 'view'">{{dataForm.fax}}</span>
                                <el-input v-else v-model="dataForm.fax" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价人姓名" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="quotationName">
                                <span v-if="viewFlag === 'view'">{{dataForm.quotationName}}</span>
                                <el-input v-else v-model="dataForm.quotationName" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="职务" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="quotationPosition">
                                <span v-if="viewFlag === 'view'">{{dataForm.quotationPosition}}</span>
                                <el-input v-else v-model="dataForm.quotationPosition" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="部门" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="width:100px;margin-bottom: 0;" prop="dept">
                                <span v-if="viewFlag === 'view'">{{dataForm.dept}}</span>
                                <el-input v-else v-model="dataForm.dept" maxlength="20" style="width:250px;"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item></el-descriptions-item>
                        <el-descriptions-item></el-descriptions-item>
                    </el-descriptions>
                </div>
                <el-row :gutter="40">
                    <el-col :span="24" style="text-align:right;">
                        <el-button size="small" @click="viewData.visible = false">
                            取消
                        </el-button>
                        <el-button v-if="viewFlag !== 'view'" :loading="this.dataFormDisabled" size="small" type="primary" plain @click="dataFormSubmit()">
                            保存
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-tab-pane>
        <el-tab-pane key="quotationMaterial" label="原材料报价" name="quotationMaterial" v-if="chooseFlag">
            <quotationMaterial-tab ref="quotationMaterial" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationMaterial-tab>
        </el-tab-pane>
        <el-tab-pane key="quotationOutBuy" label="外购零部件费" name="quotationOutBuy" v-if="chooseFlag">
            <quotationOutBuy-tab ref="quotationOutBuy" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationOutBuy-tab>
        </el-tab-pane>
        <el-tab-pane key="quotationConversion" label="加工费换算" name="quotationConversion" v-if="chooseFlag">
            <quotationConversion-tab ref="quotationConversion" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationConversion-tab>
        </el-tab-pane>
        <el-tab-pane key="quotationProcessCost" label="加工费" name="quotationProcessCost" v-if="chooseFlag">
            <quotationProcessCost-tab ref="quotationProcessCost" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationProcessCost-tab>
        </el-tab-pane>
        <el-tab-pane key="quotationToolsCost" label="模具夹具检具成本" name="quotationToolsCost" v-if="chooseFlag">
            <quotationToolsCost-tab ref="quotationToolsCost" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationToolsCost-tab>
        </el-tab-pane>
       <el-tab-pane key="quotationDesignCost" label="实验,设计成本" name="quotationDesignCost" v-if="chooseFlag">
            <quotationDesignCost-tab ref="quotationDesignCost" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationDesignCost-tab>
        </el-tab-pane>
        <el-tab-pane key="quotationBox" label="包装运输费" name="quotationBox" v-if="chooseFlag">
            <quotationBox-tab ref="quotationBox" :roundNo="this.roundNo" :dataFromParent="this.dataForm"></quotationBox-tab>
        </el-tab-pane>
    </el-tabs>
    <common-user-dialog ref="commonUserDialog"></common-user-dialog>
    <!--        createPosition CreatePosition CREATE_POSITION
createUser  CreateUser  CREATE_USER
-->
    <!-- 弹窗, 新增 / 修改 零件-->
    <!-- 生产量纲 -->
    <!--        <add-or-update-dimension v-if="addOrUpdateDimensionVisible" ref="addOrUpdateDimension" @refreshDimensionDataList="getDimensionList"></add-or-update-dimension>-->
    <!-- 弹窗, 新增 / 修改 汇率表-->
    <!-- 汇率表 -->
    <!--        <add-or-update-rate v-if="addOrUpdateRateVisibe" ref="addOrUpdateRate" @refreshRateDataList="getProjectRateList"></add-or-update-rate>-->
</el-dialog>
</template>

<script>
import {
    addPartPrice,
    editPartPrice,
    getSupplierRfqPartsByVenderId,
    getPartToatlPrice,
    getToolsAndDesignByPart
} from '@/controller/quotation'
import moment from 'moment'
import {
    CAR_TYPE,
    getCAR_TYPE,
    PROJECT_STATUS,
    getLabelByValue,
} from '@/utils/const'
// import {CHECK_NUMBER} from '@/utils/common';
import CommonUserDialog from "@/views/common/common-user-dialog";
import quotationMaterialTab from '../quotationMaterial/quotationMaterial-tab'
import quotationProcessCostTab from '../quotationMaterial/quotationProcessCost-tab'
import quotationConversionTab from '../quotationMaterial/quotationConversion-tab'
import quotationToolsCostTab from '../quotationMaterial/quotationToolsCost-tab'
import quotationDesignCostTab from '../quotationMaterial/quotationDesignCost-tab'
import quotationOutBuyTab from '../quotationMaterial/quotationOutBuy-tab'
import quotationBoxTab from '../quotationMaterial/quotationBox-tab'
import CtlNumber from '@/views/common/ctl-number'
import {
    mapping,
    mappingNotNull
} from '@/utils'
import {
    setLoading
} from "@/utils/index";
// import AddOrUpdateDimension from "./dimension-add-or-update"; // 生产量纲
// import AddOrUpdateRate from "./rate-add-or-update";
// import FileUpDown from "@/views/common/file-up-down";

export default {
    components: {
        CommonUserDialog,
        quotationMaterialTab,
        quotationProcessCostTab,
        quotationConversionTab,
        quotationToolsCostTab,
        quotationDesignCostTab,
        quotationOutBuyTab,
        quotationBoxTab,
        CtlNumber
        // AddOrUpdateDimension, // 生产量纲表
        // AddOrUpdateRate, // 汇率表
        // FileUpDown //上传附件
    },
    data() {
        var checkData = (rule, value, callback) => {
            console.log(rule);
            if (this.chooseFlag == 0 && (value === null|| isNaN(value))) {
                this.dataFormDisabled = false
                return callback(rule.message)
            }else{
                callback()
            }
        };
        var checkData1 = (rule, value, callback) => {
            if (value === null || isNaN(value)) {
                this.dataFormDisabled = false
                return callback(rule.message)
            }else{
                callback()
            }
        };
        return {
            TAX: 0.13,
            chooseFlag: 1,
            vender: null,
            FILE_BIZ_TYPE: 6,
            viewData: {
                visible: false,
                width: ''
            },
            activeName: '',
            dimensionList: [],
            rateList: [],
            disabled_flag: true,
            CAR_TYPE: CAR_TYPE,
            getCAR_TYPE: getCAR_TYPE,
            PROJECT_STATUS: PROJECT_STATUS,
            getLabelByValue: getLabelByValue,
            addOrUpdateDimensionVisible: false,
            addOrUpdateRateVisibe: false,
            dataFormDisabled:false,
            viewFlag: '',
            partId: '',
            rfqId: '',
            supplierId: '',
            roundNo: 0,
            data: {},
            dataForm: {
                id:0,
                rfqId:'',
                roundNo:0,
                materialCost: 0,
                materialImportCost: 0,
                outsidePartCost: 0,
                importOutsidePartCost: 0,
                processingCost: 0,
                productionCostSum: 0,
                managementCost: 0,
                saleCost: 0,
                accountCost: 0,
                midiumCostSum: 0,
                priceBit:'',
                profit: 0,
                productUnitPrice: 0,
                packageFee: 0,
                transportFee: 0,
                feeCostSum: 0,
                totalInvest: 0,
                amortizationMoney: 0,
                totalCost: 0,
                taxCost: 0,
                salePriceCost: 0,
                quotationName: '',
                quotationPosition: '',
                chooseFlag: 0,
                toolsTotalInvestment:0, //模具总投资额
                toolsPayRatio:0, //模具支付比例
                toolsAmortizationAmount:0, //模具 摊销金额
                toolsAmortizationNum:0, //模具 摊销数量
                toolsPartAllocation:0, //模具 分摊单价
                designTotalInvestment:0, //实验设计 费用明细
                designPayRatio:0, //实验设计 支付比例
                designAmortizationAmount:0, //实验设计 摊销金额
                designAmortizationNum:0, //实验设计 摊销数量
                designPartAllocation:0, //实验设计 分摊单价
                factoryCity:'',
                factoryDistrict:'',
                distanceToBj:'',
                produceEnergy:'',
                workRate:0,
                tel:'',
                fax:'',
                quotationName:'',
                quotationPosition:'',
                dept:'',
            },
            toolsAndDesighInfo:{
              toolsTotalInvestment:0, //模具总投资额
              tools_pay_ratio:'0%', //模具支付比例
              tools_amortization_amount:0, //模具 摊销金额
              tools_amortization_num:0, //模具 摊销数量
              tools_share_price:0, //模具 分摊单价
              design_totalInvestment:0, //实验设计 费用明细
              design_pay_ratio:'0%', //实验设计 支付比例
              design_amortization_amount:0, //实验设计 摊销金额
              design_amortization_num:0, //实验设计 摊销数量
              design_share_price:0, //实验设计 分摊单价
            },
            dataRule: {
                materialCost: [{
                    message: '请输入原材料',
                    trigger: 'blur',
                    validator: checkData,
                }],
                outsidePartCost: [{
                    message: '请输入外购零件',
                    trigger: 'blur',
                    validator: checkData,
                }],
                processingCost: [{
                    message: '请输入加工费',
                    trigger: 'blur',
                    validator: checkData,
                }],
                packageFee: [{
                    message: '请输入包装费',
                    trigger: 'blur',
                    validator: checkData,
                }],
                transportFee: [{
                    message: '请输入运输费',
                    trigger: 'blur',
                    validator: checkData,
                }],
                designTotalInvestment: [{
                    message: '请输入费用明细',
                    trigger: 'blur',
                    validator: checkData,
                }],
                designPayRatio: [{
                    message: '请输入支付比例',
                    trigger: 'blur',
                    validator: checkData,
                }],
                designAmortizationNum: [{
                    message: '请输入摊销数量',
                    trigger: 'blur',
                    validator: checkData,
                }],
                toolsTotalInvestment: [{
                    message: '请输入总投资额',
                    trigger: 'blur',
                    validator: checkData,
                }],
                toolsPayRatio: [{
                    message: '请输入支付比例',
                    trigger: 'blur',
                    validator: checkData,
                }],
                toolsAmortizationNum: [{
                    message: '请输入摊销数量',
                    trigger: 'blur',
                    validator: checkData,
                }],
                managementCost: [{
                    message: "请输入管理费用",
                    trigger: "blur",
                    validator: checkData1,
                }],
                saleCost: [{
                    message: "请输入销售费用",
                    trigger: "blur",
                    validator: checkData1,
                }],
                accountCost: [{
                    message: "请输入财务费用",
                    trigger: "blur",
                    validator: checkData1,
                }],
                profit: [{
                    message: "请输入利润",
                    trigger: "blur",
                    validator: checkData1,
                }],
            },
            
        }
    },
    watch: {
        'dataForm.productionCostSum': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                this.changeToJ('D', nval);
            },
            deep: true, // 深度监听
        },
        'dataForm.midiumCostSum': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                this.changeToJ('H', nval);
            },
            deep: true, // 深度监听
        },
        'dataForm.profit': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                this.changeToJ('I', nval);
            },
            deep: true, // 深度监听
        },
        'dataForm.productUnitPrice': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                this.changeToM('J', nval);
            },
            deep: true, // 深度监听
        },
        'dataForm.feeCostSum': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                this.changeToO('M', nval);
            },
            deep: true, // 深度监听
        },
        'dataForm.totalCost': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                if (!this.dataForm) {
                    return
                }
                this.dataForm.taxCost = nval * this.TAX
            },
            deep: true, // 深度监听
        },
        'dataForm.taxCost': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                if (!this.dataForm) {
                    return
                }
                this.dataForm.salePriceCost = nval + this.dataForm.totalCost
            },
            deep: true, // 深度监听
        },

    },
    mounted() {},
    methods: {
        formatNumber(event) {
            let value = event.target.value;
            event.target.value = CHECK_NUMBER(value);
        },
        changeToO(key, value) { //MN
            if (!this.dataForm) {
                return
            }
            let feeCostSum = this.dataForm.feeCostSum ? this.dataForm.feeCostSum : 0;
            let amortizationMoney = this.dataForm.amortizationMoney ? this.dataForm.amortizationMoney : 0;
            if (key == 'M') {
                feeCostSum = value
            } else {
                amortizationMoney = value
            }
            this.dataForm.totalCost = feeCostSum + amortizationMoney
        },
        changeToToolsRatio(){
            if (!this.dataForm) {
                return
            }
            let toolsTotalInvestment = this.dataForm.toolsTotalInvestment ? this.dataForm.toolsTotalInvestment : 0;
            let toolsPayRatio = this.dataForm.toolsPayRatio ? this.dataForm.toolsPayRatio : 0;
            let toolsAmortizationNum = this.dataForm.toolsAmortizationNum ? this.dataForm.toolsAmortizationNum : 0;
            this.dataForm.toolsAmortizationAmount = toolsTotalInvestment*(1-toolsPayRatio/100)
            if(this.dataForm.toolsAmortizationNum === 0 || this.dataForm.toolsAmortizationNum === null){
                this.dataForm.toolsPartAllocation = 0
            }else{
                this.dataForm.toolsPartAllocation = this.dataForm.toolsAmortizationAmount/toolsAmortizationNum
            }
            let feeCostSum = this.dataForm.feeCostSum ? this.dataForm.feeCostSum : 0;

            this.dataForm.feeCostSum = this.dataForm.productUnitPrice + this.dataForm.designPartAllocation + this.dataForm.toolsPartAllocation
        },
        changeDesignRatio(){
            if (!this.dataForm) {
                return
            }
            let designTotalInvestment = this.dataForm.designTotalInvestment ? this.dataForm.designTotalInvestment : 0;
            let designPayRatio = this.dataForm.designPayRatio ? this.dataForm.designPayRatio : 0;
            let designAmortizationNum = this.dataForm.designAmortizationNum ? this.dataForm.designAmortizationNum : 0;
            this.dataForm.designAmortizationAmount = designTotalInvestment*(1-designPayRatio/100)
            if(this.dataForm.designAmortizationNum === 0 || this.dataForm.designAmortizationNum === null){
                this.dataForm.designPartAllocation = 0
            }else{
                this.dataForm.designPartAllocation = this.dataForm.designAmortizationAmount/designAmortizationNum
            }
            this.dataForm.feeCostSum = this.dataForm.productUnitPrice + this.dataForm.designPartAllocation + this.dataForm.toolsPartAllocation
        },
        changeToM(key, value) { //JKL
            if (!this.dataForm) {
                return
            }
            let productUnitPrice = this.dataForm.productUnitPrice ? this.dataForm.productUnitPrice : 0;
            let packageFee = this.dataForm.packageFee ? this.dataForm.packageFee : 0;
            let transportFee = this.dataForm.transportFee ? this.dataForm.transportFee : 0;
            if (key == 'J') {
                productUnitPrice = value
            } else if (key == 'K') {
                packageFee = value
            } else {
                transportFee = value
            }
            // if(key == 'K' && this.dataForm.chooseFlag === 0){
            //     productUnitPrice = this.fixedNumber(packageFee) 
            //     + this.fixedNumber(productionCostSum) + this.fixedNumber(midiumCostSum)
            // } else if(key == 'L' && this.dataForm.chooseFlag === 0){
            //     productUnitPrice = this.fixedNumber(transportFee) + this.fixedNumber(productionCostSum) + this.fixedNumber(midiumCostSum)
            // }
            console.log(packageFee);
            this.dataForm.productUnitPrice = this.fixedNumber(this.dataForm.productionCostSum) + this.fixedNumber(this.dataForm.midiumCostSum) + this.fixedNumber(this.dataForm.profit) + packageFee + transportFee
            this.dataForm.feeCostSum = productUnitPrice + this.dataForm.designPartAllocation + this.dataForm.toolsPartAllocation
        },
        changeToJ(key, value) { //DHI
            if (!this.dataForm) {
                return
            }
            let productionCostSum = this.dataForm && this.dataForm.productionCostSum ? this.dataForm.productionCostSum : 0;
            let midiumCostSum = this.dataForm && this.dataForm.midiumCostSum ? this.dataForm.midiumCostSum : 0;
            let profit = this.dataForm && this.dataForm.profit ? this.dataForm.profit : 0;
            if (key == 'D') {
                productionCostSum = value
            } else if (key == 'H') {
                midiumCostSum = value
            } else {
                profit = value
            }
            this.dataForm.productUnitPrice = this.fixedNumber(productionCostSum) + this.fixedNumber(midiumCostSum) + this.fixedNumber(profit);
        },
        changeToH(key, value) { //EFG
            if (!this.dataForm) {
                return
            }
            let managementCost = this.dataForm.managementCost ? this.dataForm.managementCost : 0;
            let saleCost = this.dataForm.saleCost ? this.dataForm.saleCost : 0;
            let accountCost = this.dataForm.accountCost ? this.dataForm.accountCost : 0;
            if (key == 'E') {
                managementCost = value
            } else if (key == 'F') {
                saleCost = value
            } else {
                accountCost = value
            }
            this.dataForm.midiumCostSum = managementCost + saleCost + accountCost;
        },
        changeToD(key, value) { //ABC
            if (!this.dataForm) {
                return
            }
            let total = 0;
            let materialCost = this.dataForm.materialCost ? this.dataForm.materialCost : 0;
            let outsidePartCost = this.dataForm.outsidePartCost ? this.dataForm.outsidePartCost : 0;
            let processingCost = this.dataForm.processingCost ? this.dataForm.processingCost : 0;
            if (key == 'A') {
                this.dataForm.materialCost = value;
                total = value + outsidePartCost + processingCost
            } else if (key == 'B') {
                this.dataForm.outsidePartCost = value;
                total = materialCost + value + processingCost
            } else {
                this.dataForm.processingCost = value;
                total = materialCost + outsidePartCost + value
            }
            this.dataForm.productionCostSum = total;
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("yyyy-MM-DD")
        },
        init(row, vender, viewFlag, roundNo) {
            debugger
            this.vender = vender;
            this.viewFlag = viewFlag;
            this.dataForm.id = row.id;
            this.dimensionList = [];
            this.rateList = [];
            this.viewData.visible = true
            this.activeName = 'totalPanel'
            this.partId = row.rfqPartId
            console.log(row.rfqId);
            this.dataForm.rfqId = row.rfqId
            this.rfqId = row.rfqId
            this.supplierId = row.rfqSupplierId
            this.rowNo = row.rowNo
            this.roundNo = roundNo
            this.dataForm.roundNo = roundNo
            this.chooseFlag = row.chooseFlag === null ? 1 : row.chooseFlag
            this.$nextTick(() => {
                //初始化上传附件
                // this.$refs.FileUpDown.init(id,this.FILE_BIZ_TYPE,null);
                this.$refs['dataForm'].resetFields()

                this.dataForm = Object.assign({}, row);
                this.dataForm.chooseFlag = this.chooseFlag
                this.handleClick()
                this.dataForm.rfqId = row.rfqId
                this.dataForm.id = row.id;
            })
        },
        // 表单提交
        dataFormSubmit() {
            // var sumMoney = this.fixedNumber(this.dataForm.feeCostSum)+this.toolsAndDesighInfo.tools_share_price+this.toolsAndDesighInfo.design_share_price
            
            // if(sumMoney <= 0){
            //     this.$message.error("请先报价,在保存")
            //     return
            // }
            this.dataFormDisabled = true
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = this.dataForm
                    params.rfqId = this.rfqId
                    params.chooseFlag = this.chooseFlag
                    // debugger
                    if (this.dataForm.id) {
                        editPartPrice(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body.id;
                                this.$message({
                                    duration: 1000,
                                    type: 'success',
                                    message: '提交成功',
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.$emit('refreshDataList')
                                        }
                                    })
                            } else {
                                this.$message.error(data.msg)
                            }
                            setTimeout(() => {
                                this.dataFormDisabled = false
                            }, 3000)
                        })
                    } else {
                        addPartPrice(params).then(data => {
                            if (data && data.code === '00' && data.body) {
                                this.dataForm.id = data.body.id;
                                this.$message({
                                    duration: 1000,
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                            setTimeout(() => {
                                this.dataFormDisabled = false
                            }, 3000)
                        })
                    }
                    
                }
            })
        },
        // 校验数据
        validData() {
            if(this.viewFlag !== 'view') {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.viewData.visible = false
                    } else {
                        this.viewData.visible = true
                        this.$message({
                            message: "请检查报价汇总信息必输项信息",
                            type: "warning"
                        });
                    }
                })
            } else {
                this.viewData.visible = false
            }
        },
        handleClick(tab) {
            const _this = this
            // TODO： 查询总报价
            if (this.activeName === 'totalPanel') {
                // if (this.chooseFlag) {
                //     let param = {
                //       rfqId: this.rfqId,
                //       rfqSupplierId: this.supplierId,
                //       rfqPartId: this.partId,
                //       managementCost: this.dataForm.managementCost ? this.dataForm.managementCost : 0,
                //       profit: this.dataForm.profit ? this.dataForm.profit : 0,
                //       saleCost: this.dataForm.saleCost ? this.dataForm.saleCost : 0,
                //       accountCost: this.dataForm.accountCost ? this.dataForm.accountCost : 0,
                //       roundNo: this.roundNo,
                //     }
                //     // 调用求和视图
                //     getPartToatlPrice(param).then((data) => {
                //         if (data && data.code === "00") {
                //             if (data.body !== null) {
                //                 mapping(data.body, _this.dataForm)
                //                 mappingNotNull(_this.data, _this.dataForm)
                //             } else {
                //                 this.initialForm()
                //             }
                //         }
                //     });
                // //   getToolsAndDesignByPart(param).then((data) => {
                // //     if (data && data.code === "00") {
                // //       if (data.body !== null) {
                // //         mapping(data.body, _this.toolsAndDesighInfo)
                // //       } else {
                // //         this.initialForm()
                // //       }
                // //     }
                // //   });
                // } else {
                    // 否则调用本表
                    getSupplierRfqPartsByVenderId({
                        id: this.rfqId,
                        venderId: this.vender.id,
                        partId: this.partId
                    }).then((data) => {
                        if (data && data.code === "00" && data.body.length > 0) {
                            mapping(data.body[0], this.dataForm)
                            this.$forceUpdate();
                        } else {
                            this.initialForm()
                        }
                    });
                // }
            } else {
                this.$refs[this.activeName].init(this.rfqId, this.partId, this.supplierId, this.roundNo, this.viewFlag,this.vender)
            }
        },
        changePriceMode(val) {
            // TODO： 查询总报价
            // if (this.chooseFlag) {
            //     // 调用求和视图
            //     getPartToatlPrice({
            //         rfqId: this.rfqId,
            //         rfqSupplierId: this.supplierId,
            //         rfqPartId: this.partId,
            //         roundNo: this.roundNo,
            //         managementCost: this.dataForm.managementCost ? this.dataForm.profit : 0,
            //         profit: this.dataForm.profit ? this.dataForm.profit : 0,
            //         saleCost: this.dataForm.saleCost ? this.dataForm.saleCost : 0,
            //         accountCost: this.dataForm.accountCost ? this.dataForm.accountCost : 0
            //     }).then((data) => {
            //         if (data && data.code === "00") {
            //             if (data.body !== null) {
            //                 mapping(data.body, this.dataForm)
            //                 mappingNotNull(this.data, this.dataForm)
            //             } else {
            //                 this.initialForm()
            //             }
            //             this.dataForm.chooseFlag = val
            //         }
            //     });
            // } else {
            //     // 否则调用本表
            //     getRfqPartsByVenderId({
            //         id: this.rfqId,
            //         venderId: this.vender.id,
            //         partId: this.partId
            //     }).then((data) => {
            //         if (data && data.code === "00" && data.body.length > 0) {
            //             mapping(data.body[0], this.dataForm)
            //         } else {
            //             this.initialForm()
            //         }
            //         this.dataForm.chooseFlag = val
            //     });
            // }
        },
        initialForm() {
          return ;
            this.dataForm.materialCost = 0
            this.dataForm.materialImportCost = 0
            this.dataForm.outsidePartCost = 0
            this.dataForm.importOutsidePartCost = 0
            this.dataForm.processingCost = 0
            this.dataForm.productionCostSum = 0
            this.dataForm.managementCost = 0
            this.dataForm.saleCost = 0
            this.dataForm.accountCost = 0
            this.dataForm.midiumCostSum = 0
            this.dataForm.profit = 0
            this.dataForm.productUnitPrice = 0
            this.dataForm.packageFee = 0
            this.dataForm.transportFee = 0
            this.dataForm.feeCostSum = 0
            this.dataForm.totalInvest = 0
            this.dataForm.amortizationMoney = 0
            this.dataForm.totalCost = 0
            this.dataForm.taxCost = 0
            this.dataForm.salePriceCost = 0
            this.dataForm.chooseFlag = 1
            this.dataForm.toolsTotalInvestment= 0 //模具总投资额
            this.dataForm.toolsPayRatio= 0//模具支付比例
            this.dataForm.toolsAmortizationAmount= 0 //模具 摊销金额
            this.dataForm.toolsAmortizationNum= 0 //模具 摊销数量
            this.dataForm.toolsPartAllocation= 0 //模具 分摊单价
            this.dataForm.designTotalInvestment= 0 //实验设计 费用明细
            this.dataForm.designPayRatio= 0 //实验设计 支付比例
            this.dataForm.designAmortizationAmount= 0 //实验设计 摊销金额
            this.dataForm.designAmortizationNum= 0 //实验设计 摊销数量
            this.dataForm.designPartAllocation= 0 //实验设计 分摊单价
        },
        // ================ 生产量纲表格 ========================
        // // 查产销计划表
        // getDimensionList(year='') {
        //     getDimensionList({
        //         year:year,
        //         projectId: this.dataForm.id
        //     }).then((data) => {
        //         if (data && data.code === "00") {
        //             this.dimensionList = data.body.records;
        //         } else {
        //             this.dimensionList = [];
        //         }
        //     });
        // },
        // // 删除量纲
        // deleteHandleDimension(id) {
        //     let ids = id ?
        //         [id] :
        //         this.dataListSelections.map((item) => {
        //             return item.id;
        //         });
        //     this.$confirm(`确定进行删除操作?`, "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     })
        //         .then(() => {
        //             removeDimension(ids)
        //                 .then((data) => {
        //                     if (data && data.code === "00") {
        //                         this.$message({
        //                             message: "操作成功",
        //                             type: "success",
        //                             duration: 1500,
        //                             onClose: () => {
        //                                 this.getDimensionList();
        //                             },
        //                         });
        //                     } else {
        //                         this.$message.error(data.msg);
        //                     }
        //                 })
        //                 .catch((error) => {
        //                     console.log(error);
        //                 });
        //         })
        //         .catch(() => {});
        // },
        // // 产销计划
        // // 新增 / 修改 产销计划表
        // addOrUpdateDimensionHandle(id) {
        //     this.addOrUpdateDimensionVisible = true;
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdateDimension.init(id, this.dataForm.id);
        //     });
        // },
        // // ================ 汇率表表格 ========================
        // // 查询汇率表
        // getProjectRateList() {
        //     // console.log(this.dataForm.id, 'this.dataForm.id')
        //     getProjectRateList({projectId:this.dataForm.id}).then((data) => {
        //         if (data && data.code === "00") {
        //             this.rateList = data.body.records;
        //         } else {
        //             this.rateList = [];
        //         }
        //     });
        // },
        // // 删除汇率表
        // deleteRate(id) {
        //     this.$confirm(`确定进行删除操作?`, "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     })
        //         .then(() => {
        //             removeRate({}, id)
        //                 .then((data) => {
        //                     if (data && data.code === "00") {
        //                         this.$message({
        //                             message: "操作成功",
        //                             type: "success",
        //                             duration: 1500,
        //                             onClose: () => {
        //                                 this.getProjectRateList();
        //                             },
        //                         });
        //                     } else {
        //                         this.$message.error(data.msg);
        //                     }
        //                 })
        //                 .catch((error) => {
        //                     console.log(error);
        //                 });
        //         })
        //         .catch(() => {});
        // },
        // // 新增 / 修改 汇率表
        // addOrUpdateRateHandle(id) {
        //     this.addOrUpdateRateVisibe = true;
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdateRate.init(id, this.dataForm.id);
        //     });
        // },
        fixedNumber(val) {
            if (!val || isNaN(val)) {
                return 0
            }
            return Number(Number(val).toFixed(this.dataForm.priceBit))
        },
        fixedNumber3(val) {
            if (!val || isNaN(val)) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        getStyle() {
            return 'width: 300px; text-align: right'
        },
        getStyleRed() {
            return 'width: 300px; text-align: right;background-color:#E6A23C;'
        },
        
        getStyle2() {
            return 'width: 435.5px;'
        }
    },
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

form.el-form.org-dialog-form {
    width: 100%;
}

.linetext {
    white-space: pre-line;
}

.el-tabs__item {
    user-select: none;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}

.mb15 {
    margin-bottom: 15px;
}

.el-form-item__error {
    padding-top: 0;
}
</style>
